import React, { useState } from 'react';
import { useEffect } from 'react';

type Props = {
  className?: string;
  customValidate?: (value: { value: string; valueAsNumber: number }) => boolean;
  defaultValue?: number | null;
  disabled?: boolean;
  inputMode?: 'none' | 'text' | 'numeric' | 'decimal';
  max?: number;
  min?: number;
  onChange: (value: { valid: boolean; value: number }) => void;
  placeholder?: string;
  step?: number;
  value?: number | null;
  onFocus?: () => void;
  onBlur?: () => void;
};

/**
 *
 * @param props
 * @returns
 * @deprecated InputNumber2を使用し、InputNumberの使用箇所がなくなったら名称を交換したい
 */
const InputNumber: React.FC<Props> = props => {
  const customValidate = props.customValidate || (() => true);
  const min = props.min || 0;
  const step = props.step || 1;
  const [value, setValue] = useState(
    props.defaultValue === undefined || props.defaultValue === null
      ? ''
      : props.defaultValue.toString()
  );

  useEffect(() => {
    if (props.value === undefined) {
      return;
    }
    setValue(props.value?.toString() ?? '');
  }, [props.value]);

  function handleChange(value: string, valueAsNumber: number) {
    setValue(value);
    const valid = (() => {
      if (Number.isNaN(valueAsNumber)) {
        return false;
      }
      if (valueAsNumber % step !== 0) {
        return false;
      }
      if (valueAsNumber < min || (props.max && props.max < valueAsNumber)) {
        return false;
      }
      if (!customValidate({ value, valueAsNumber })) {
        return false;
      }
      return true;
    })();
    props.onChange({
      valid: valid,
      value: valid ? valueAsNumber : 0,
    });
  }

  return (
    <>
      {/* stepup, stepdownはハンドリングが非常に複雑なので制御しない */}
      <input
        className={props.className}
        disabled={props.disabled}
        inputMode={props.inputMode}
        max={props.max}
        min={min}
        onChange={event =>
          handleChange(
            event.currentTarget.value,
            event.currentTarget.valueAsNumber
          )
        }
        placeholder={props.placeholder}
        step={step}
        value={value}
        type="number"
        onFocus={props.onFocus}
        onBlur={props.onBlur}
      />
    </>
  );
};

export default InputNumber;
